import React, { useState, useEffect } from 'react';
import './Ballon.css';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { CloudfrontVideoFormat } from '../../../videos/CloudfrontVideoFormat';
import Practice1 from '../../../Unit1/Module1/Module1Practice';
import Practice2 from '../../../Unit1/Module3/FacialExpressionPractice';
import Practice3 from '../../../Unit1/Module4/PosturePractice';
import Practice4 from '../../../Unit1/Module5/DistancePractice';
import PracticeSituation from '../../Practice/PracticeSituation';

/**
 * Plays the celebrate video module shown at the end of each day
 * @param {*} props
 * @returns the HTML code for the celebrate module
 */
export default function BallonPractice(props) {
  // Initialize variables to be used later

  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [ballons, setBallons] = useState(false);
  const [ballon1, setBallon1] = useState(true);
  const [ballon2, setBallon2] = useState(false);
  const [ballon3, setBallon3] = useState(false);
  const [ballon4, setBallon4] = useState(false);
  const [effect1, setEffect1] = useState('bounceIcons');
  const [effect2, setEffect2] = useState('');
  const [effect3, setEffect3] = useState('');
  const [effect4, setEffect4] = useState('');
  const [practice, setPractice] = useState('');
  const [openPractice, setOpenPractice] = useState(false);
  const [ballonScene, setBallonScene] = useState(true);
  const [displayLearnVideo, setDisplayLearnVideo] = useState(true);
  const [daysText, setDaysText] = useState('');
  const [learnVideo, setlearnVideo] = useState(props.video1);
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;
  
  const bounceSound = new Audio(generateImageUrl('media/Module1Videos/button_bouncing.mp3'));
  const touchSound = new Audio(generateImageUrl('media/Module1Videos/touch_button.mp3'));
  const ballon1Img = generateImageUrl('images/Module16Images/Balloon 1_1.svg');
  const ballon2Img = generateImageUrl('images/Module16Images/Balloon 2_1.svg');
  const ballon3Img = generateImageUrl('images/Module16Images/Balloon 3_1.svg');
  const ballon4Img = generateImageUrl('images/Module16Images/Balloon 4_1.svg');
  const string1Img = generateImageUrl('images/Module16Images/Balloon+String+1.svg');
  const string2Img = generateImageUrl('images/Module16Images/Balloon+String+2.svg');
  const string3Img = generateImageUrl('images/Module16Images/Balloon+String+3.svg');
  const string4Img = generateImageUrl('images/Module16Images/Balloon+String+4.svg');
  const optionYesPlease = {
      img: generateImageUrl('images/Module16Images/practice/yes please.png'),
      title: 'Yes, please',
      audioPrompt: 'appfiles/manners/option_yes_please.mp3',
  };
  const optionNoThankYou = {
      img: generateImageUrl('images/Module16Images/practice/no thank you.png'),
      title: 'No, thank you',
      audioPrompt: 'appfiles/manners/option_no_thank_you.mp3',
  };
  const optionSorry = {
      img: generateImageUrl('images/Module16Images/practice/I_m sorry.png'),
      title: 'I am sorry',
      audioPrompt: 'appfiles/manners/option_sorry.mp3',
  };
  const optionExcuseMe = {
      img: generateImageUrl('images/Module16Images/practice/excuse me.png'),
      title: 'Excuse me',
      audioPrompt: 'appfiles/manners/option_excuse_me.mp3',
  };
  const optionBeSilent = {
      img: generateImageUrl('images/Module16Images/practice/be silent.png'),
      title: 'Be silent and listen',
      audioPrompt: 'appfiles/manners/option_be_silent.mp3',
  };
  const optionCalmVoice = {
      img: generateImageUrl('images/Module16Images/practice/use a calm voice.png'),
      title: 'Use a calm voice',
      audioPrompt: 'appfiles/manners/option_calm_voice.mp3',
  };
  const optionLoudVoice = {
      img: generateImageUrl('images/Module16Images/practice/use a loud voice.png'),
      title: 'Use an outdoor voice',
      audioPrompt: 'appfiles/manners/option_loud_voice.mp3',
  };
  const optionWhisper = {
      img: generateImageUrl('images/Module16Images/practice/whisper.png'),
      title: 'Whisper',
      audioPrompt: 'appfiles/manners/option_whisper.mp3',
  };

  /// /////////////////////////////////////////////
  const wantSomething = {
    prompt:
      'If someone offers you something you would like to have, you should say',
    audioPrompt: 'appfiles/manners/scenario_want_something.mp3',
    correctMatch: optionYesPlease,
    incorrectMatches: [optionNoThankYou, optionSorry],
  };

  const dontWantSomething = {
    prompt: 'If someone offers you something you do not want you should say',
    audioPrompt: 'appfiles/manners/scenario_dont_want_something.mp3',
    correctMatch: optionNoThankYou,
    incorrectMatches: [optionYesPlease, optionExcuseMe],
  };

  const makeMistake = {
    prompt: 'If you make a mistake you should say',
    audioPrompt: 'appfiles/manners/scenario_make_mistake.mp3',
    correctMatch: optionSorry,
    incorrectMatches: [optionYesPlease, optionNoThankYou],
  };

  const getAttention = {
    prompt: `If you need someone's attention, you should say`,
    audioPrompt: 'appfiles/manners/scenario_get_attention.mp3',
    correctMatch: optionExcuseMe,
    incorrectMatches: [optionYesPlease, optionNoThankYou],
  };

  const needToListen = {
    prompt: 'If someone is talking to you and you need to listen, you should',
    audioPrompt: 'appfiles/manners/scenario_need_listen.mp3',
    correctMatch: optionBeSilent,
    incorrectMatches: [optionCalmVoice, optionLoudVoice],
  };

  const othersNotHear = {
    prompt:
      'If you need to tell someone something, but you do not want others to hear what you are saying, you should',
    audioPrompt: 'appfiles/manners/scenario_others_not_hear.mp3',
    correctMatch: optionWhisper,
    incorrectMatches: [optionBeSilent, optionLoudVoice],
  };

  const talkingAtPicnic = {
    prompt:
      'If you are talking to your family while having a picnic, you should',
    audioPrompt: 'appfiles/manners/scenario_talking_at_picnic.mp3',
    correctMatch: optionCalmVoice,
    incorrectMatches: [optionBeSilent, optionLoudVoice],
  };

  const getFriendsAttention = {
    prompt:
      'If you are playing outside with friends and are trying to get your friends attention, you should',
    audioPrompt: 'appfiles/manners/scenario_get_friends_attention.mp3',
    correctMatch: optionLoudVoice,
    incorrectMatches: [optionBeSilent, optionWhisper],
  };

  //
  const [Exit, setExit] = useState(
    generateImageUrl('images/Images/close.png')
  );

  const displayPractice = (num) => {
    if (num === 1) {
      if (props.module.currentday === 1) {
        setPractice(
          <Practice1
            setDisplayPractice={setOpenPractice}
            background={props.background}
            stepComplete={''}
            module={props.module}
            unit4={true}
            next={() => (
              setEffect1(''), setEffect2('bounceIcons'), setBallon2(true),
              sleep(700).then(() => {
                bounceSound.play()
              })
            )}
          />
        );
      } else if (props.module.currentday === 2) {
        setPractice(
          <PracticeSituation
            options={[wantSomething]}
            title={'Manners: What I say'}
            setDisplayPractice={setOpenPractice}
            background={props.background}
            stepComplete={''}
            module={props.module}
            next={() => (
              setEffect1(''), setEffect2('bounceIcons'), setBallon2(true),
              sleep(700).then(() => {
                bounceSound.play()
              })
            )}
          />
        );
      } else if (props.module.currentday === 3) {
        setPractice(
          <PracticeSituation
            options={[needToListen]}
            title={'Manners: How I say it'}
            setDisplayPractice={setOpenPractice}
            background={props.background}
            stepComplete={''}
            module={props.module}
            next={() => (
              setEffect1(''), setEffect2('bounceIcons'), setBallon2(true),
              sleep(700).then(() => {
                bounceSound.play()
              })
            )}
          />
        );
      }
    } else if (num === 2) {
      if (props.module.currentday === 1) {
        setPractice(
          <Practice2
            setDisplayPractice={setOpenPractice}
            background={props.background}
            stepComplete={''}
            module={props.module}
            unit4={true}
            next={() => (
              setEffect2(''), setEffect3('bounceIcons'), setBallon3(true),
              sleep(700).then(() => {
                bounceSound.play()
              })
            )}
          />
        );
      } else if (props.module.currentday === 2) {
        setPractice(
          <PracticeSituation
            options={[dontWantSomething]}
            title={'Manners: What I say'}
            setDisplayPractice={setOpenPractice}
            background={props.background}
            stepComplete={''}
            module={props.module}
            next={() => (
              setEffect2(''), setEffect3('bounceIcons'), setBallon3(true),
              sleep(700).then(() => {
                bounceSound.play()
              })
            )}
          />
        );
      } else if (props.module.currentday === 3) {
        setPractice(
          <PracticeSituation
            options={[othersNotHear]}
            title={'Manners: How I say it'}
            setDisplayPractice={setOpenPractice}
            background={props.background}
            stepComplete={''}
            module={props.module}
            next={() => (
              setEffect2(''), setEffect3('bounceIcons'), setBallon3(true),
              sleep(700).then(() => {
                bounceSound.play()
              })
            )}
          />
        );
      }
    } else if (num === 3) {
      if (props.module.currentday === 1) {
        setPractice(
          <Practice3
            setDisplayPractice={setOpenPractice}
            background={props.background}
            stepComplete={''}
            module={props.module}
            unit4={true}
            next={() => (
              setEffect3(''), setEffect4('bounceIcons'), setBallon4(true),
              sleep(700).then(() => {
                bounceSound.play()
              })
            )}
          />
        );
      } else if (props.module.currentday === 2) {
        setPractice(
          <PracticeSituation
            options={[makeMistake]}
            title={'Manners: What I say'}
            setDisplayPractice={setOpenPractice}
            background={props.background}
            stepComplete={''}
            module={props.module}
            next={() => (
              setEffect3(''), setEffect4('bounceIcons'), setBallon4(true),
              sleep(700).then(() => {
                bounceSound.play()
              })
            )}
          />
        );
      } else if (props.module.currentday === 3) {
        setPractice(
          <PracticeSituation
            options={[talkingAtPicnic]}
            title={'Manners: How I say it'}
            setDisplayPractice={setOpenPractice}
            background={props.background}
            stepComplete={''}
            module={props.module}
            next={() => (
              setEffect3(''), setEffect4('bounceIcons'), setBallon4(true),
              sleep(700).then(() => {
                bounceSound.play()
              })
            )}
          />
        );
      }
    } else if (num === 4) {
      if (props.module.currentday === 1) {
        setPractice(
          <Practice4
            setDisplayPractice={setOpenPractice}
            background={props.background}
            stepComplete={''}
            module={props.module}
            unit4={true}
            next={() => (props.ended())}
          />
        );
      } else if (props.module.currentday === 2) {
        setPractice(
          <PracticeSituation
            options={[getAttention]}
            title={'Manners: What I say'}
            setDisplayPractice={setOpenPractice}
            background={props.background}
            stepComplete={''}
            module={props.module}
            next={() => (props.ended())}
          />
        );
      } else if (props.module.currentday === 3) {
        setPractice(
          <PracticeSituation
            options={[getFriendsAttention]}
            title={'Manners: How I say it'}
            setDisplayPractice={setOpenPractice}
            background={props.background}
            stepComplete={''}
            module={props.module}
            next={() => (props.ended())}
          />
        );
      }
    }
    setOpenPractice(true);
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  useEffect(() => {
    switch (props.module.currentday){
      case 1: 
        setDaysText('Manners: How I Act')
        break;
      case 2: 
        setDaysText('Manners: What I Say')
        break;
      case 3: 
        setDaysText('Manners: How I say it')
        break;
      default: 
        break;
    }
  }, []);

  // The actual HTML code that determines whether to show the module above.
  return (
    <>
      {openPractice && practice}
      {ballonScene && !openPractice && (
        <div
          className='ballonScene'
          style={{ backgroundImage: `url(${props.background})` }}
        >
          {displayLearnVideo && (
            <CloudfrontVideoFormat
              source={learnVideo}
              back={'unit4'}
              background={props.background}
              close={props.setDisplayPractice}
              ended={() => {
                setDisplayLearnVideo(false);
                setBallons(true);
                sleep(700).then(() => {
                  bounceSound.play()
                });
              }}
            />
          )}
          <img
            className='back-btn-ftb'
            src={Exit}
            onClick={() => {
              props.setDisplayPractice(false);
            }}
          ></img>
          <br/>
          {!displayLearnVideo && (<h2 className='practiceSituationHeader'>{daysText}</h2>)}
          {ballons && (
            <div className='crab_ballon'>
              <div className='ballons'>
                {ballon1 && (
                  <div
                    className='ballon_string1'
                    onClick={() => {
                      sleep(500).then(() => {
                        displayPractice(1);
                      });
                      touchSound.play()
                    }}
                  >
                    <img
                      alt=''
                      className='ballon1'
                      id={effect1}
                      src={ballon1Img}
                    />
                    <br />
                    <img alt='' className='string1' src={string1Img} />
                  </div>
                )}
                {ballon2 && (
                  <div
                    className='ballon_string2'
                    onClick={() => {
                      sleep(500).then(() => {
                        displayPractice(2);
                      });
                      touchSound.play()
                    }}
                  >
                    <img
                      alt=''
                      className='ballon2'
                      id={effect2}
                      src={ballon2Img}
                    />
                    <br />
                    <img alt='' className='string2' src={string2Img} />
                  </div>
                )}
                {ballon3 && (
                  <div
                    className='ballon_string3'
                    onClick={() => {
                      sleep(500).then(() => {
                        displayPractice(3);
                      });
                      touchSound.play()
                    }}
                  >
                    <img
                      alt=''
                      className='ballon3'
                      id={effect3}
                      src={ballon3Img}
                    />
                    <br />
                    <img alt='' className='string3' src={string3Img} />
                  </div>
                )}
                {ballon4 && (
                  <div
                    className='ballon_string4'
                    onClick={() => {
                      sleep(500).then(() => {
                        displayPractice(4);
                      });
                      touchSound.play()
                    }}
                  >
                    <img
                      alt=''
                      className='ballon4'
                      id={effect4}
                      src={ballon4Img}
                    />
                    <br />
                    <img alt='' className='string4' src={string4Img} />
                  </div>
                )}
              </div>
              {<img alt='' className='animateAnimal' src={props.animal} />}
            </div>
          )}
        </div>
      )}
    </>
  );
}
